import axios from "axios"
import { useEffect,useState } from "react"
import {format,parse} from 'date-fns'
import flecha from '../Img/flecha.png'
import AddProyecto from "./AddProyecto"
import EditProyecto from "./EditProyecto"
import DelProyecto from "./DelProyecto"
export default function Proyectos({usuario}){
    const columnas=["Cliente","Centro","Nombre","Descripción","Inicio"]
    const [clientes,setClientes]=useState([])
    const [centros,setCentros]=useState([])
    const [proyectos,setProyectos]=useState([])
    const [begin,setBegin]=useState(parse("01/01/2000","dd/MM/yyyy",new Date()))
    const [end,setEnd]=useState(parse(formatString(new Date()),"dd/MM/yyyy",new Date()))
    const [accion,setAccion]=useState("")
    function formatString(date){
        const d = new Date(date)
        const dia = d.getDate().toString().padStart(2, '0');
        const mes = (d.getMonth() + 1).toString().padStart(2, '0');
        const año = d.getFullYear();
        return `${dia}/${mes}/${año}`;
    }
    function formatString2(str){
            const d=new Date(str)
            const dia = d.getDate().toString().padStart(2, '0')
            const mes = (d.getMonth() + 1).toString().padStart(2, '0')
            const año = d.getFullYear()
            const hora=d.getHours().toString().padStart(2, '0')
            const min=d.getMinutes().toString().padStart(2, '0')
            const sec=d.getSeconds().toString().padStart(2, '0')
            return `${dia}/${mes}/${año} ${hora}:${min}:${sec}`
    }
    function formatStringReverse(str){
        const d=new Date(str)
        const dia = d.getDate().toString().padStart(2, '0');
        const mes = (d.getMonth() + 1).toString().padStart(2, '0');
        const año = d.getFullYear();
        const hora=d.getHours()
        const min=d.getMinutes()
        const sec=d.getSeconds()
        return `${año}/${mes}/${dia} ${hora}:${min}:${sec}`
    }
    const ChangeBegin=(event)=>{
        const valores=event.target.value.split("-")
        if (event.target.value.length==0 || valores[0].length>4){
            setBegin(parse("2000-01-01","yyyy-MM-dd",new Date()))
        }
        else{
            setBegin(parse(event.target.value,"yyyy-MM-dd",new Date()))
            if (parse(event.target.value,"yyyy-MM-dd",new Date())>end){
                setEnd(parse(event.target.value,"yyyy-MM-dd",new Date()))
            }
        }
    }
    const ChangeEnd=(event)=>{
        const valores=event.target.value.split("-")
        if (event.target.value.length==0 || valores[0].length>4){
            setEnd(new Date())
        }
        else{
            setEnd(parse(event.target.value,"yyyy-MM-dd",new Date()))
            if (parse(event.target.value,"yyyy-MM-dd",new Date())<begin){
                setBegin(parse(event.target.value,"yyyy-MM-dd",new Date()))
            }
        }
    }
    useEffect(()=>{
        let clientesOrdenados=[]
        let centrosOrdenados=[]
        axios.get("https://www.asinova.es/webapi/api/Clientes")
            .then(res=>{
                clientesOrdenados=res.data.sort((x,y)=>x.nombre.localeCompare(y.nombre))
                setClientes(clientesOrdenados)
                return axios.get("https://www.asinova.es/webapi/api/Centros")})
            .then(res=>{
                centrosOrdenados=res.data.sort((x,y)=>x.nombre.localeCompare(y.nombre)).sort((x, y) => clientesOrdenados.find(cliente=>cliente.id==x.id_cliente).nombre.localeCompare(clientesOrdenados.find(cliente=>cliente.id==y.id_cliente).nombre))
                setCentros(centrosOrdenados)
                return axios.get("https://www.asinova.es/webapi/api/Proyectos")})
            .then(res=>{
                setProyectos(res.data.sort((x,y)=>x.nombre.localeCompare(y.nombre)).sort((x,y)=>formatStringReverse(y.inicio).localeCompare(formatStringReverse(x.inicio))))
            })
    },[])
    return(
        <>
            <h1 style={{textAlign:'center',margin:'1rem'}}>PROYECTOS</h1>
            {usuario.administrador?
            <div className="div-opciones">
                <a className="btn-form" onClick={()=>setAccion(accion=="post"?"":"post")}>Añadir</a>
                <a className="btn-form" onClick={()=>setAccion(accion=="put"?"":"put")}>Editar</a>
                <a className="btn-form" onClick={()=>setAccion(accion=="delete"?"":"delete")}>Eliminar</a>
            </div>
            :null}
            <div className="flex mid" style={{margin:'0 auto'}}>
                <p>Inicio</p>
                <input type="date" name='inicio' value={format(begin,"yyyy-MM-dd")} style={{marginTop:0}} onChange={ChangeBegin}/>
                <div className="flex column" style={{marginBottom:'1rem'}}>
                    <img src={flecha} style={{width:'30px',marginBottom:'1rem'}} className='pointer' onClick={()=>setEnd(begin)}/>
                    <img src={flecha} style={{width:'30px',transform:'rotate(180deg)'}} className='pointer' onClick={()=>setBegin(end)}/>
                </div>
                <input type="date" name="fin" value={format(end,"yyyy-MM-dd")} style={{marginTop:0}} onChange={ChangeEnd}/>
                <p>Fin</p>
            </div>
            <table style={{margin:'0rem auto 1rem auto',borderRadius:'5px'}}>
                <tr>
                    {columnas.map((col,index)=>(
                        <th key={index}>{col}</th>
                    ))}
                </tr>
                {proyectos.filter(x=>new Date(x.inicio)>=begin && parse(formatString(new Date(x.inicio)),"dd/MM/yyyy",new Date())<=end).map(x=>(
                    <tr><td>{clientes.find(y=>y.id==centros.find(z=>z.id==x.id_centro).id_cliente).nombre}</td><td>{centros.find(y=>x.id_centro==y.id).nombre}</td><td>{x.nombre}</td><td style={{maxWidth:'450px'}}>{x.descripcion}</td><td>{formatString2(x.inicio)}</td></tr>
                ))}
            </table>
            {accion!=""?
                <div className="ventana-emergente">
                    <a className="btn-form" onClick={()=>setAccion("")} style={{padding:'0.1rem 0.45rem',marginTop:'1rem',float:'right'}}>X</a>
                    {accion=="post"?
                    <AddProyecto clientes={clientes} centros={centros} setProyectos={setProyectos}/>:
                    accion=="put"?
                    <EditProyecto clientes={clientes} centros={centros} proyectos={proyectos} setProyectos={setProyectos}/>:
                    <DelProyecto clientes={clientes} centros={centros} proyectos={proyectos} setProyectos={setProyectos}/>
                    }                    
                </div>
                :null}
        </>
    )
}